export default __webpack_public_path__ + "static/media/3.462e2a21.jpg";